var map = {
	"./Brand.png": 46979,
	"./Category.png": 19267,
	"./City.png": 17468,
	"./District.png": 57415,
	"./Feature.png": 12,
	"./Group.png": 68141,
	"./Hotel.png": 17679,
	"./Markland.png": 48198,
	"./MetroStation.png": 14477,
	"./RailwayStation.png": 76262,
	"./Zone.png": 6682,
	"./arrow-down.png": 8516,
	"./history.png": 5047,
	"./other.png": 66550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95662;